// IMPORT BASICS
import React, { useState, useEffect, useRef, memo } from "react";
import ReactDOMServer from "react-dom/server";

//IMPORT GTAG
import gtag from "ga-gtag";

//IMPORT COMPONENTS
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ReactToPrint from "react-to-print";
import WarningIcon from "@mui/icons-material/Warning";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import TableBody from "@mui/material/TableBody";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button.js";
import MuiAlert from "@mui/material/Alert"; //SNACKBAR
import Snackbar from "@mui/material/Snackbar"; //SNACKBAR
import Box from "@mui/material/Box"; // POP UP VERTRAGSENTWURF
import Modal from "@mui/material/Modal"; // POP UP VERTRAGSENTWURF
import Fade from "@mui/material/Fade"; // POP UP VERTRAGSENTWURF
import Backdrop from "@mui/material/Backdrop"; // POP UP VERTRAGSENTWURF
import Typography from "@mui/material/Typography"; // POP UP VERTRAGSENTWURF
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Checkbox from "@mui/material/Checkbox";

// IMPORT CUSTOM
import TableToPrintHeader from "./TableToPrintHeader.js";
import TableToPrintEmpty from "./TableToPrintEmpty.js";

//IMPORT CUSTOM
import Line from "../Line/Line.js";
import TextField from "../TextField/TextField.js";
import TextFieldForm from "../TextField/TextFieldForm";
import { ComponentToPrint } from "../Print/ComponentToPrint.js";
import { ComponentToPrintAN } from "../Print/ComponentToPrintAN.js";
import { ComponentToPrintAI } from "../Print/ComponentToPrintAI.js";
import MissingField from "../MissingField/MissingField.js";

//IMPORT DATA
import { required } from "../../data/options.data.js";

//IMPORT STYLES
import styles from "./TableToPrint.module.scss";
import { isValidFormat } from "../../utils/isValidFormat.js";

//IMPORT STYLES HEADLESS CHROME HTML
import styles_for_print from "../Print/ComponentToPrint.module.scss";

//IMPORT IMAGE
import Highlight_off_icon from "../../../src/Highlight_off_icon.png";

const TableToPrint = (props) => {
  // ROUTER
  const navigate = useNavigate();

  //PROPS
  const { labels, result, structure, values, language } = props;

  //STATES
  const [openEnt, setOpenEnt] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const defaultContact = {
    name: "",
    vorname: "",
    telefon: "0041",
    adresse: "",
    stadt: "",
    land: labels[language].kontaktland,
    postleitzahl: "",
  };
  const [openForm, setOpenForm] = useState(false);
  const [contact, setContact] = useState(defaultContact);
  const [errorForm, setErrorForm] = useState({});
  const [acceptedGDPR, setAcceptedGDPR] = useState(false);

  // REFS
  let componentRef1 = useRef();
  let componentRef2 = useRef();
  let componentRef3 = useRef();
  let componentRef4 = useRef();
  let componentRef5 = useRef();
  let componentRef6 = useRef();
  let componentRef7 = useRef();
  let componentRef8 = useRef();
  let componentRef9 = useRef();
  const refs = { componentRef7, componentRef8, componentRef9 };
  //FUNCTIONS
  // ******************************************************************
  // A function that fetches the Api and posts Data for Contract Draft
  //***************************************************************** */
  async function sendDraftParams(errorForm, values, result) {
    let missing = {};
    for (let i = 0; i < required.form.length; i++) {
      const field = required.form[i];
      const content = contact[field];
      let message = "";
      if (field === "email") {
        message = isValidFormat(content, "email");
      } else if (field === "telefon") {
        message = isValidFormat(content, "phone");
      } else if (field === "postleitzahl") {
        //if statement with or condition
        message = isValidFormat(content, "zipcode");
      } else if (field === "gdpr") {
        message = acceptedGDPR ? "" : "gdpr_error";
      } else {
        message = content === "" || !content ? "empty" : "";
      }
      if (message !== "") missing[field] = message;
    }
    setErrorForm(missing);

    if (Object.values(missing).length === 0) {
      gtag("event", "Anfrage");
      const tempResult = { ...result };
      // RENAMING
      //grade1
      tempResult.grade1.ag.bvg_or = tempResult.grade1.ag.bgv_or;
      delete tempResult.grade1.ag.bgv_or;
      tempResult.grade1.ag.bvg_os = tempResult.grade1.ag.bgv_os;
      delete tempResult.grade1.ag.bgv_os;
      tempResult.grade1.ag.bvg_ueo = tempResult.grade1.ag.bgv_ueo;
      delete tempResult.grade1.ag.bgv_ueo;
      //grade4
      tempResult.grade4.ag.bvg_or = tempResult.grade4.ag.bgv_or;
      delete tempResult.grade4.ag.bgv_or;
      tempResult.grade4.ag.bvg_os = tempResult.grade4.ag.bgv_os;
      delete tempResult.grade4.ag.bgv_os;
      tempResult.grade4.ag.bvg_ueo = tempResult.grade4.ag.bgv_ueo;
      delete tempResult.grade4.ag.bgv_ueo;
      //grade9
      tempResult.grade9.ag.bvg_or = tempResult.grade9.ag.bgv_or;
      delete tempResult.grade9.ag.bgv_or;
      tempResult.grade9.ag.bvg_os = tempResult.grade9.ag.bgv_os;
      delete tempResult.grade9.ag.bgv_os;
      tempResult.grade9.ag.bvg_ueo = tempResult.grade9.ag.bgv_ueo;
      delete tempResult.grade9.ag.bgv_ueo;

      //RESTRUCTURING
      tempResult.config_grade1 = tempResult.grade1.config;
      // delete tempResult.grade1.config;
      tempResult.config_grade4 = tempResult.grade4.config;
      // delete tempResult.grade4.config;
      tempResult.config_grade9 = tempResult.grade9.config;
      // delete tempResult.grade9.config;

      // SET CURRENT DATE OF FORMULAR SUBMISSION
      const currentDate = new Date();
      const date = `${currentDate.getDate()}/${
        currentDate.getMonth() + 1
      }/${currentDate.getFullYear()}`;

      // BUILD MAIL URL
      const url =
        "https://payroll.rmgroup.ch/" +
        "?date=" +
        date +
        "&age=" +
        values.age +
        "&lan=" +
        values.lan +
        "&sex=" +
        values.sex +
        "&bir=" +
        values.bir +
        "&tgf=" +
        values.tgf +
        "&tgp=" +
        values.tgp +
        "&tgt=" +
        values.tgt +
        "&pen=" +
        values.pen +
        "&hrw=" +
        values.hrw +
        "&vac=" +
        values.vac +
        "&msp=" +
        values.msp +
        "&ckt=" +
        values.ckt +
        "&can=" +
        values.can +
        "&tar=" +
        values.tar +
        "&chi=" +
        values.chi +
        "&chh=" +
        values.chh +
        "&con=" +
        values.con +
        "&prf=" +
        values.prf +
        "&prf_grade1=" +
        values.prf_grade1 +
        "& prf_grade4=" +
        values.prf_grade4 +
        "&prf_grade9=" +
        values.prf_grade9 +
        "&pro=" +
        [] +
        "&bvg=" +
        values.bvg;

      const data = {
        secret: "ObNaSMZiSu5F7P576utzR",
        contact: contact,
        values: {
          // date: date,

          // sex: values.sex,
          // age: values.age,
          // birthday: values.bir,
          // target_for: values.tgf,
          // target_pro: values.tgp,
          // target: values.tgt,
          // pensum: values.pen,
          // hours_pw: values.hrw,
          // vacation: values.vac,
          // msp: values.msp,
          // check_taxAtSource: values.ckt,
          // canton: values.can,
          // tarif: values.tar,
          // children: values.chi,
          // children_household: values.chh,
          // confession: values.con,
          // prf: values.prf,
          // prf_grade1: values.prf_grade1,
          // prf_grade4: values.prf_grade4,
          // prf_grade9: values.prf_grade9,
          // provisions: [],
          // bvg: values.bvg,

          date: date,

          sex: values.sex,
          age: values.age,
          bir: values.bir,
          tgf: values.tgf,
          tgp: values.tgp,
          tgt: values.tgt,
          pen: values.pen,
          hrw: values.hrw,
          vac: values.vac,
          msp: values.msp,
          ckt: values.ckt,
          can: values.can,
          tar: values.tar,
          chi: values.chi,
          chh: values.chh,
          con: values.con,
          prf: values.prf,
          prf_grade1: values.prf_grade1,
          prf_grade4: values.prf_grade4,
          prf_grade9: values.prf_grade9,
          pro: [],
          bvg: values.bvg,
        },
        config_grade_1: tempResult.config_grade1,
        results_grade_1: tempResult.grade1,
        url: url,
      };
      if (result.grade4.isgav === "nongav") {
        data["config_grade_4"] = tempResult.config_grade4;
        data["results_grade_4"] = tempResult.grade4;
      }
      if (result.grade9.isgav === "nongav") {
        data["config_grade_9"] = tempResult.config_grade9;
        data["results_grade_9"] = tempResult.grade9;
      }
      const response_mmg = await fetch(
        "https://eoa3awyhppzd7lb.m.pipedream.net",
        {
          method: "POST",
          body: JSON.stringify(data),
        }
      );
      const response_RM = await fetch(
        "https://api.rmgroup.ch/v1/core/public/requestcalc",
        {
          method: "POST",
          body: JSON.stringify(data),
        }
      );
      // console.log("URL - test", url);
      gtag("event", "Anfrage");
      setErrorForm({});
      setContact(defaultContact);
      setOpenForm(false);
      setOpenEnt({ ...openEnt, open: true });
    }
  }

  ////////////////////////////////////////////////
  ////////// Formular Functions //////////////////
  ////////////////////////////////////////////////
  const updateContactValues = (label, value) => {
    const tmpContact = { ...contact };
    tmpContact[label] = value;
    setContact(tmpContact);
  };

  const handleOpenForm = () => {
    setOpenForm(true);
  };

  const handleCancelForm = () => {
    setContact(defaultContact);
    setErrorForm({});
    setOpenForm(false);
  };

  const { open } = openEnt;

  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenEnt({ ...openEnt, open: false });
  };
  // CALCULATIONS

  // Prüfe den Basissatz auf Stundebasis

  const basissatz = {};
  for (let key in result) {
    const item = result[key];
    basissatz[key] =
      (item.basissatz * item.config.multiplier) / item.config.hours_pj;
  }

  //______________________________________________________________________________________________________//
  ////////////////////////////////////////////////////////////////////////////////////////////////////////
  //          Transform components to HTML; Generate Full Headless Chrome compatible HTML
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  //----------------------------------------------------------------------------------------------------//

  const componentsToConvert = [
    <ComponentToPrint
      content={result.grade1}
      values={values}
      grade="Grade 1"
      ref={(el) => (componentRef1 = el)}
      language={language}
    />,
    <ComponentToPrint
      content={result.grade4}
      values={values}
      grade="Grade 4"
      ref={(el) => (componentRef2 = el)}
      language={language}
    />,
    <ComponentToPrint
      content={result.grade9}
      values={values}
      grade="Grade 9"
      ref={(el) => (componentRef3 = el)}
      language={language}
    />,
  ];

  //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%//
  //////////////////////////////////////////////////////////////////////////////////////////////
  // a function that generates the indices of all occurences of a classname in the HTML sample //
  ///////////////////////////////////////////////////////////////////////////////////////////////

  function getIndicesOfWord(longString, word) {
    let indices = [];
    let i = 0;
    while (i < longString.length) {
      i = longString.indexOf(word, i);
      if (i === -1) {
        break;
      }
      indices.push(i);
      i++;
    }

    return indices;
  }

  //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%//
  //////////////////////////////////////////////////////////////////////////////////////////////
  // a function cuts the generated Classname to usable Classname in the StaticMarkup output //
  ///////////////////////////////////////////////////////////////////////////////////////////////

  const toOriginalClass = (longString, arrayOfIndices, originalClassName) => {
    function cutSubstring(inputString, startIndex, endIndex) {
      return inputString.slice(startIndex, endIndex);
    }
    function concatenateStrings(str1, str2, str3) {
      return str1 + str2 + str3;
    }
    let tmpLongString = longString;

    for (let i = 0; i < arrayOfIndices.length; i++) {
      // cut to original className
      let cutClassName;
      cutClassName = concatenateStrings(
        cutSubstring(tmpLongString, 0, arrayOfIndices[i] - 17),
        originalClassName,
        cutSubstring(
          tmpLongString,
          arrayOfIndices[i] + originalClassName.length + 7,
          tmpLongString.length
        )
      );

      //set as new reference
      tmpLongString = cutClassName;

      // adjust indices array for all coming indices
      for (let j = i + 1; j < arrayOfIndices.length; j++) {
        arrayOfIndices[j] = arrayOfIndices[j] - 24;
        // console.log("ARRAY_OF_INDICES", arrayOfIndices);
      }
    }

    longString = tmpLongString;
    return longString;
  };

  //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%//
  //////////////////////////////////////////////////////////////////////////////////////////////
  // A function that generates a usable HTML BODY for RM Headless Chrome Tool                 //
  ///////////////////////////////////////////////////////////////////////////////////////////////

  const generateBodyMainDiv = (classNames, bodyDiv) => {
    let outputBodyDiv;
    for (let i = 0; i < classNames.length; i++) {
      // 2: replace through longstring
      outputBodyDiv = toOriginalClass(
        bodyDiv,
        // 1: get indices for 1 className
        getIndicesOfWord(bodyDiv, classNames[i]),
        classNames[i]
      );
      bodyDiv = outputBodyDiv;
    }

    return bodyDiv;
  };

  //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%//
  //////////////////////////////////////////////////////////////////////////////////////////
  // a function that sends POST Request with full HTML to RM CORE API                     //
  //////////////////////////////////////////////////////////////////////////////////////////

  // Manually define style tag : to be incorporated into <head></head>
  const htmlHeaderDiv =
    "<head> <link rel='preconnect' href='https://fonts.googleapis.com' /> <link rel='preconnect' href='https://fonts.gstatic.com' crossorigin /> <link href='https://fonts.googleapis.com/css2?family=Titillium+Web&family=Varela+Round&display=swap' rel='stylesheet' /><style>body {font-family: 'Titillium Web', Helvetica, Arial, sans-serif !important;} .payrollWrapper {padding: 2rem; display: flex; flex-direction: column;}.payrollWrapper .print_table { font-family: 'Titillium Web', Helvetica, Arial, sans-serif !important;color: #212121 !important;font-size: 12px !important; }.payrollWrapper thead.print_head {width: 2000px !important;background-color: #e85412 !important;}.payrollWrapper thead.print_head th {padding: 0.275rem !important;color: white !important;text-align: right !important;}.payrollWrapper thead.print_head th:first-child {text-align: left !important;}.payrollWrapper .simple_row td {padding: 0.225rem !important;color: #212121 !important;text-align: right !important;border-bottom: 0.35px solid rgba(224, 224, 224, 1) !important;line-height: 12px !important; }.payrollWrapper .simple_row td:first-child {text-align: left !important;}.payrollWrapper .rowbold td {padding: 0.25rem !important;color: #212121 !important;text-align: right !important;border-bottom: 0.35px solid rgba(224, 224, 224, 1) !important;font-weight: bold !important;line-height: 12px !important;}.payrollWrapper .rowbold td:first-child {text-align: left !important;}.payrollWrapper .subrow td {padding: 0.1rem 0.4rem !important;color: #212121 !important;text-align: right !important;background-color: #f6f6f6 !important;border-bottom: 0.5px solid rgba(224, 224, 224, 1) !important;font-size: 10px !important;}.payrollWrapper .subrow td:first-child {text-align: left !important;padding-left: 1rem !important;} .payrollWrapper .empty td {padding: 0.2rem !important;line-height: 8px !important;} .payrollWrapper .grid_header td {background-color: #e85412 !important;padding: 0.275rem !important;color: white !important;text-align: right !important;font-weight: bold !important;} .payrollWrapper .grid_header td:first-child {text-align: left !important;} .payrollWrapper .lastrow td {padding: 0.2rem !important;color: #212121 !important;text-align: right !important;border-bottom: 0.5px solid rgba(224, 224, 224, 1) !important;font-size: 10px !important;background-color: #f2f8fc !important;} .payrollWrapper .lastrow td:first-child {text-align: left !important;} .text td {text-align: left !important;font-size: 10px !important;padding: 0px !important;margin: 0px !important;line-height: 12px !important;color: #212121 !important;} </style></head>";

  async function postHtmlToEndpoint(body_div, header_styles) {
    // concatenate html parts
    function makeBodyHtml(str1, str2, str3) {
      return str1 + str2 + str3;
    }
    // concatenate HTML
    function concatenateHtml(str1, str2, str3, str4) {
      return str1 + str2 + str3 + str4;
    }

    const htmlBody = makeBodyHtml("<body>", body_div, "</body>");

    const htmlContent = concatenateHtml(
      "<html>",
      header_styles,
      htmlBody,
      "</html>"
    );
    // console.log("HTML CONTENT", htmlContent);

    const response_mmg = await fetch(
      "https://eoa3awyhppzd7lb.m.pipedream.net",
      {
        method: "POST",
        // body: JSON.stringify(htmlContent),
        body: htmlContent,
      }
    );

    let headless_chrome_mmg;
    let headless_chrome_RM;
    headless_chrome_mmg = await response_mmg.json();
    // headless_chrome_RM = await response_RM.json();
    // console.log("HEADLESS_CHROME_RETURN_MMG", headless_chrome_mmg);
    // console.log("HEADLESS_CHROME_RETURN_RM", headless_chrome_RM);
    return headless_chrome_mmg, headless_chrome_RM; //or set values Object with min deduction and taxrates
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////
  ///// TEST::: GENERATE A BODY HTML WITH CORRECT CLASSNAMES                                 //////
  //////////////////////////////////////////////////////////////////////////////////////////////////

  //DECLARATION OF CLASSNAMES
  const scssClassNames = [
    "payrollWrapper",
    "print_table",
    "print_head",
    "simple_row",
    "rowbold",
    "subrow",
    "empty",
    "grid_header",
    "lastrow",
    "text",
  ];

  // CONVERT COMPONENT TO HTML STRING

  // const componentToHtml1 = generateBodyMainDiv(
  //   scssClassNames,
  //   ReactDOMServer.renderToStaticMarkup(componentsToConvert[0]) //  generates Body html content Grade 1
  // );
  // const componentToHtml4 = generateBodyMainDiv(
  //   scssClassNames,
  //   ReactDOMServer.renderToStaticMarkup(componentsToConvert[1]) //  generates Body html content Grade 1
  // );

  // const componentToHtml9 = generateBodyMainDiv(
  //   scssClassNames,
  //   ReactDOMServer.renderToStaticMarkup(componentsToConvert[2]) //  generates Body html content Grade 1
  // );

  // postHtmlToEndpoint(componentToHtml1, htmlHeaderDiv);
  //render
  return (
    <>
      <div className="table payrollContainer">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <ReactToPrint
                  trigger={() => (
                    <div className="print_icon">
                      <LocalPrintshopIcon /> <p>Print All</p>
                    </div>
                  )}
                  content={() => componentRef1}
                />
                {/* </div> */}
              </TableCell>

              {result.grade4.isgav === "nongav" ? (
                <TableCell>
                  <div>
                    {/* <div
                      onClick={() =>
                        postHtmlToEndpoint(componentToHtml4, htmlHeaderDiv)
                      }
                    > */}
                    <ReactToPrint
                      trigger={() => (
                        <div className="print_icon">
                          <LocalPrintshopIcon /> <p>Print All</p>
                        </div>
                      )}
                      content={() => componentRef2}
                    />
                  </div>
                  {/* </div> */}
                </TableCell>
              ) : null}
              {result.grade9.isgav === "nongav" ? (
                <TableCell>
                  {/* <div
                    onClick={() =>
                      postHtmlToEndpoint(componentToHtml9, htmlHeaderDiv)
                    }
                  > */}
                  <ReactToPrint
                    trigger={() => (
                      <div className="print_icon">
                        <LocalPrintshopIcon /> <p>Print All</p>
                      </div>
                    )}
                    content={() => componentRef3}
                  />
                  {/* </div> */}
                </TableCell>
              ) : null}
            </TableRow>
            <TableToPrintHeader
              label={labels[language].arbeitgeber}
              result={result}
            />
          </TableHead>
          <TableBody>
            {structure.ag.map((item, index) => {
              return (
                <Line
                  key={index}
                  content={item}
                  result={result}
                  language={language}
                  values={values}
                  refs={refs}
                />
              );
            })}
            <TableToPrintEmpty result={result} />
            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <ReactToPrint
                  trigger={() => (
                    <div className="print_icon">
                      <LocalPrintshopIcon /> <p>Print</p>
                    </div>
                  )}
                  content={() => componentRef4}
                />
                {/* </div> */}
              </TableCell>

              {result.grade4.isgav === "nongav" ? (
                <TableCell>
                  <div>
                    {/* <div
                      onClick={() =>
                        postHtmlToEndpoint(componentToHtml4, htmlHeaderDiv)
                      }
                    > */}
                    <ReactToPrint
                      trigger={() => (
                        <div className="print_icon">
                          <LocalPrintshopIcon /> <p>Print</p>
                        </div>
                      )}
                      content={() => componentRef5}
                    />
                  </div>
                  {/* </div> */}
                </TableCell>
              ) : null}
              {result.grade9.isgav === "nongav" ? (
                <TableCell>
                  {/* <div
                    onClick={() =>
                      postHtmlToEndpoint(componentToHtml9, htmlHeaderDiv)
                    }
                  > */}
                  <ReactToPrint
                    trigger={() => (
                      <div className="print_icon">
                        <LocalPrintshopIcon /> <p>Print</p>
                      </div>
                    )}
                    content={() => componentRef6}
                  />
                  {/* </div> */}
                </TableCell>
              ) : null}
            </TableRow>
            <TableToPrintHeader
              label={labels[language].arbeitnehmer}
              result={result}
            />
            {structure.an.map((item, index) => {
              return (
                <Line
                  key={index}
                  content={item}
                  result={result}
                  language={language}
                  values={values}
                  refs={refs}
                />
              );
            })}
          </TableBody>
        </Table>
        {basissatz.grade1 < 30 ||
        basissatz.grade4 < 30 ||
        basissatz.grade9 < 30 ? (
          <div className="home_warning">
            <div>
              <WarningIcon />
            </div>
            {labels[language].gav}
          </div>
        ) : null}
        <div className="entwurf_container">
          <Button
            execute={() => {
              handleOpenForm();
            }}
            language={language}
            values={values}
          >
            <div>{labels[language].vertrags_entwurf}</div>
          </Button>
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openForm}
          onClose={handleCancelForm}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          className={styles["contactmodal"]}
        >
          <Fade in={openForm}>
            <Box className={styles["pop_up_box"]}>
              <Box
                className={styles["pop_up_box_content"]}
                style={{ color: "black" }}
              >
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                  color="secondary"
                >
                  <div
                    className={styles["title"]}
                    style={{ marginTop: "1rem", color: "whiteSmoke" }}
                  >
                    <div className={styles["highlight_off"]}>
                      <img
                        className
                        src={Highlight_off_icon}
                        width={25}
                        height={25}
                        onClick={handleCancelForm}
                      />
                      {/* <HighlightOffIcon
                        fontSize={"small"}
                        sx={{
                          bgcolor: "#9b9b9b",
                          color: "white",
                          border: "5px",
                          borderRadius: " 32px",
                        }}
                      /> */}
                    </div>
                    <b>{labels[language].contact_info}</b>

                    <p className={styles.subtext}>
                      {labels[language].vertrags_entwurf_info}
                    </p>
                  </div>
                  <div className={styles["post_land_combo"]}>
                    <div className={styles["postleitzahl"]}>
                      <TextFieldForm
                        key="name"
                        name="name"
                        updateValues={updateContactValues}
                        addon=""
                        title={labels[language].name}
                        defaultValue={contact.name || null}
                        type="fixed"
                      />
                      {errorForm.name && (
                        <MissingField
                          appearing={labels[language][errorForm.name]}
                        />
                      )}
                    </div>
                    <div className={styles["postleitzahl"]}>
                      <TextFieldForm
                        key="vorname"
                        name="vorname"
                        updateValues={updateContactValues}
                        addon=""
                        title={labels[language].vorname}
                        defaultValue={contact.vorname || null}
                        type="fixed"
                      />
                      {errorForm.vorname && (
                        <MissingField
                          appearing={labels[language][errorForm.vorname]}
                        />
                      )}
                    </div>
                  </div>
                  <TextFieldForm
                    key="adresse"
                    name="adresse"
                    updateValues={updateContactValues}
                    addon=""
                    title={labels[language].adresse}
                    defaultValue={contact.adresse || null}
                    type="fixed"
                  />
                  {errorForm.adresse && (
                    <MissingField
                      appearing={labels[language][errorForm.adresse]}
                    />
                  )}
                  <div className={styles["post_land_combo"]}>
                    <div className={styles["postleitzahl"]}>
                      <TextFieldForm
                        key="postleitzahl"
                        name="postleitzahl"
                        updateValues={updateContactValues}
                        addon=""
                        title={labels[language].postleitzahl}
                        defaultValue={contact.postleitzahl || null}
                        type="fixed"
                      />
                      {errorForm.postleitzahl && (
                        <MissingField
                          appearing={labels[language][errorForm.postleitzahl]}
                        />
                      )}
                    </div>
                    <div className={styles["postleitzahl"]}>
                      <TextFieldForm
                        key="stadt"
                        name="stadt"
                        updateValues={updateContactValues}
                        addon=""
                        title={labels[language].stadt}
                        defaultValue={contact.stadt || null}
                        type="fixed"
                      />
                      {errorForm.stadt && (
                        <MissingField
                          appearing={labels[language][errorForm.stadt]}
                        />
                      )}
                    </div>
                  </div>
                  <div className={styles["post_land_combo"]}>
                    <div className={styles["postleitzahl"]}>
                      <TextFieldForm
                        key="land"
                        name="land"
                        updateValues={updateContactValues}
                        addon=""
                        title={labels[language].land}
                        defaultValue={contact.land || null}
                        type="fixed"
                      />
                      {errorForm.land && (
                        <MissingField
                          appearing={labels[language][errorForm.land]}
                        />
                      )}
                    </div>
                    <div className={styles["postleitzahl"]}>
                      <TextFieldForm
                        key="telefon"
                        name="telefon"
                        updateValues={updateContactValues}
                        addon=""
                        title={labels[language].telefon}
                        defaultValue={contact.telefon || null}
                        type="fixed"
                      />
                      {errorForm.telefon && (
                        <MissingField
                          appearing={labels[language][errorForm.telefon]}
                        />
                      )}
                    </div>
                  </div>
                  <div className={styles["postleitzahl"]}>
                    <TextFieldForm
                      key="email"
                      name="email"
                      updateValues={updateContactValues}
                      addon=""
                      title={labels[language].email}
                      defaultValue={contact.email || null}
                      type="fixed"
                    />
                    {errorForm.email && (
                      <MissingField
                        appearing={labels[language][errorForm.email]}
                      />
                    )}
                  </div>
                  <div>
                    <div
                      className="checkbox-container"
                      style={{ marginTop: "1rem" }}
                    >
                      <Checkbox
                        checked={acceptedGDPR}
                        onClick={() => setAcceptedGDPR(!acceptedGDPR)}
                        inputProps={{ "aria-label": "controlled" }}
                        size={"small"}
                        color={"secondary"}
                      />
                      {language === "DE" && (
                        <p className={styles.gdpr_label}>
                          Ich erteile die Einwilligung in die Speicherung und
                          Verarbeitung meiner personenbezogenen Daten zu den in
                          der Datenschutzerklärung beschriebenen Zwecken des
                          Personalverleihs. Ich nehme zur Kenntnis, dass die RM
                          Group AG und ihre dazugehörigen Tochterunternehmen
                          meine Daten schützt und diese nur gemäss den{" "}
                          <a href="https://www.rmgroup.ch/csr/datenschutz/">
                            {" "}
                            Datenschutz-Richtlinien
                          </a>{" "}
                          verarbeitet.
                        </p>
                      )}
                      {language === "EN" && (
                        <p className={styles.gdpr_label}>
                          I give my consent to store and process my personal
                          data for the purposes of staff leasing as described in
                          the privacy policy. I hereby acknowledge that RM Group
                          AG and its belonging entities will protect my data and
                          process them only according to the general{" "}
                          <a href="https://www.rmgroup.ch/en/csr/data-protection/">
                            {" "}
                            Data Protection Policy
                          </a>
                          .
                        </p>
                      )}
                      {language === "FR" && (
                        <p className={styles.gdpr_label}>
                          Je donne mon consentement à l'enregistrement et au
                          traitement de mes données personnelles aux fins de la
                          location de service décrites dans la déclaration de
                          protection des données. Je prends note du fait que RM
                          Group AG et ses filiales respectives protègent mes
                          données et ne les utilisent que conformément à la{" "}
                          <a href="https://www.rmgroup.ch/csr/datenschutz/">
                            Politique de confidentialité{" "}
                          </a>
                          .
                        </p>
                      )}
                    </div>
                    <div style={{ marginTop: "1rem" }}>
                      {errorForm.gdpr && (
                        <MissingField
                          appearing={labels[language][errorForm.gdpr]}
                        />
                      )}
                    </div>
                  </div>
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 3 }}>
                  <div className={styles["button_combo"]}>
                    <Button
                      aria-label="execute"
                      language={language}
                      values={values}
                      execute={() => {
                        sendDraftParams(errorForm, values, result);
                      }}
                      disabled={!acceptedGDPR}
                    >
                      <div>{labels[language].versenden}</div>
                    </Button>
                    <Button
                      aria-label="delete"
                      language={language}
                      values={values}
                      execute={() => {
                        handleCancelForm();
                      }}
                    >
                      <div>{labels[language].abbrechen}</div>
                    </Button>
                  </div>
                </Typography>
              </Box>
            </Box>
          </Fade>
        </Modal>
        <Snackbar
          open={open}
          autoHideDuration={3500}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <MuiAlert
            severity="success"
            elevation={6}
            color="info"
            variant="filled"
            onClose={handleClose}
          >
            {language === "DE" && (
              <p className="alertText">
                Die Daten wurde erfolgreich an RM Group weitergeleitet.
              </p>
            )}
            {language === "EN" && (
              <p className="alertText">
                The Form has been sent to RM Group with success.
              </p>
            )}
            {language === "FR" && (
              <p className="alertText">
                Les données ont été transmises à RM Group avec succès.
              </p>
            )}
          </MuiAlert>
        </Snackbar>
      </div>
      {result ? (
        <div style={{ display: "none" }}>
          <ComponentToPrint
            content={result.grade1}
            values={values}
            grade="Grade 1"
            ref={(el) => (componentRef1 = el)}
            language={language}
          />
          <ComponentToPrint
            content={result.grade4}
            values={values}
            grade="Grade 4"
            ref={(el) => (componentRef2 = el)}
            language={language}
          />
          <ComponentToPrint
            content={result.grade9}
            values={values}
            grade="Grade 9"
            ref={(el) => (componentRef3 = el)}
            language={language}
          />
          <ComponentToPrintAN
            content={result.grade1}
            values={values}
            grade="Grade 1"
            ref={(el) => (componentRef4 = el)}
            language={language}
          />
          ,
          <ComponentToPrintAN
            content={result.grade4}
            values={values}
            grade="Grade 4"
            ref={(el) => (componentRef5 = el)}
            language={language}
          />
          ,
          <ComponentToPrintAN
            content={result.grade9}
            values={values}
            grade="Grade 9"
            ref={(el) => (componentRef6 = el)}
            language={language}
          />
          ,
          <ComponentToPrintAI
            content={result.grade1}
            values={values}
            grade="Grade 1"
            ref={(el) => (componentRef7 = el)}
            language={language}
          />
          ,
          <ComponentToPrintAI
            content={result.grade4}
            values={values}
            grade="Grade 4"
            ref={(el) => (componentRef8 = el)}
            language={language}
          />
          ,
          <ComponentToPrintAI
            content={result.grade9}
            values={values}
            grade="Grade 9"
            ref={(el) => (componentRef9 = el)}
            language={language}
          />
          ,
        </div>
      ) : null}
    </>
  );
};

export default memo(TableToPrint);
